// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1u-NJ","messages":"Chat_messages__sWija","dateDivider":"Chat_dateDivider__2ingD"};